<template>
  <a class="stream relative block rounded overflow-hidden text-white text-xs text-shadow visited:text-purple-700" :href="`https://twitch.tv/${channel.name}`" target="_blank" v-if="stream">
    <!-- Image -->
    <div class="relative">
      <img class="preview w-full" :src="`${stream.preview}?${previewsTimer}`" loading="lazy" />
      <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black" />
    </div>

    <!-- LIVE -->
    <div class="absolute top-0 left-0 m-2 space-y-1">
      <div class="flex items-center">
        <i class="fa fa-circle mr-1 text-red-600" />
        <div class="text-shadow" v-if="config.liveTimers && config.liveUpdates">{{ prettyDuration }}</div>
        <div v-else>LIVE</div>
      </div>
      <div class="flex items-center" :title="`Delay ${stream.delay} seconds`" v-if="stream.delay">
        <i class="fa fa-clock mr-1" />
        <div>{{ stream.delay }}s</div>
      </div>
    </div>

    <!-- Users -->
    <div class="absolute top-0 right-0 m-2 space-y-1 text-right font-bold">
      <div class="flex items-center"><i class="fa fa-user mr-1" />{{ prettyViewers }}</div>
      <div :class="viewersDiff > 0 ? 'text-green-400' : 'text-red-400'" v-if="viewersDiff">{{ prettyViewersDiff }}</div>
      <!-- <div class="text-gray-500" v-if="stream.quality">{{ stream.quality }}p</div> -->
    </div>

    <!-- Title -->
    <div class="absolute bottom-0 inset-x-0 m-2 flex items-end font-bold whitespace-normal" :title="stream.title">
      <!-- <span class="p-1 flex items-center rounded bg-red-600 text-white">LIVE</span> -->
      <!-- <i class="fa fa-circle mr-1 animate-pulse text-red-600" /> -->
      <div class="flex-1">{{ stream.title }}</div>
      <img class="ml-1 rounded-sm" width="20" height="20" :src="channel.logo" alt="" loading="lazy" v-if="config.iconType === 'Avatar' && channel.logo" />
      <img class="ml-1 rounded-sm" width="20" height="20" :src="`/avatars/50/${channel.avatar}.jpg`" alt="" loading="lazy" v-if="config.iconType === 'Logo' && channel.avatar" />
    </div>
  </a>
</template>

<script>
  import { computed } from 'vue'
  import { prettyNumber } from '@/utils'
  import { config, streamsById, channelsById, liveTimer, previewsTimer } from '@/store'

  export default {
    name: 'Stream',
    props: {
      streamId: {
        type: Number,
        required: true,
      },
    },
    setup(props) {
      const stream = computed(() => streamsById.value[props.streamId])
      const channel = computed(() => channelsById.value[props.streamId] || stream.value.channel)
      const prettyViewers = computed(() => prettyNumber(stream.value.viewers))
      const viewersDiff = computed(() => stream.value.viewers - stream.value.viewersBefore)
      const prettyViewersDiff = computed(() => (viewersDiff.value ? (viewersDiff.value > 0 ? '+' : '-') + prettyNumber(viewersDiff.value) : ''))
      const prettyDuration = computed(() => new Date(liveTimer.value - new Date(stream.value.startedAt).getTime()).toISOString().substr(11, 8))
      return { config, stream, channel, prettyViewers, viewersDiff, prettyViewersDiff, prettyDuration, previewsTimer }
    },
  }
</script>

<style scoped>
  .stream:hover .preview {
    filter: brightness(1.1);
  }
</style>
